import cx from "classnames";
import parse from "html-react-parser";

// Components
import Button from "../../../components/Button/ButtonContainer";
import Section from "../../../components/Section/SectionContainer";

// CSS
import styles from "../video.module.scss";


const VideosGlobal = (props) => {
    const { video } = props;
    const {
        related_product_title,
        related_product_description,
        related_product_url,
        related_product_image,
    } = video || {};

    return (
        <Section classes={styles.related_product}>
        <div
            className={cx(styles.related_product_container, {
                [styles["related_product_container--hidden"]]:
                    !related_product_title,
            })}
        >
            <h1 className={styles.header}>Symphony Product</h1>
            <div
                className={styles.related_product_image}
                style={{ backgroundImage: `url(${related_product_image?.sizes?.large})` }}
            >
            </div>

            <div className={styles.related_product_text}>
                <h3 className={styles.related_product_title}>{related_product_title}</h3>
                <div className={styles.related_product_description}>{related_product_description && <span>{parse(video.related_product_description)}</span>}</div>
                <a
                    href={related_product_url}
                    rel="noreferrer"
                    target="_blank"
                    className={cx(styles.related_product_link, {
                        [styles["button--hidden"]]: !related_product_url,
                    })}
                >
                    <Button
                        className={styles.related_product_button}
                        text="Learn more"
                    />
                </a>
            </div>
            </div>
        </Section>
    );
};

export default VideosGlobal;
